import React from 'react';
import styled, { css } from 'styled-components';
import { IndicatorLayoutComponentProps, Shapeable } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { useLang } from '@shapeable/ui';
import { classNames } from '@shapeable/utils';
import { MetricValue } from '../elements/metric-value';
import { Indicator } from '@shapeable/kelp-forest-alliance-types';
import { MetricLayout } from '../entities/metric-layout';
const cls = classNames('indicator-layout-value-bubble');

export type IndicatorLayoutMetricValueProps = IndicatorLayoutComponentProps & {
};

export const IndicatorLayoutMetricValueDefaultProps: Omit<IndicatorLayoutMetricValueProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    
  `,
});

const ValueStyles = breakpoints({
  base: css`
   
  `,
});


// -------- Components -------->

const My = {
    Container: styled(MetricLayout)<ContainerProps>`${ContainerStyles}`,
  Value: styled(MetricValue)`${ValueStyles}`,
};

export const IndicatorLayoutMetricValue: Shapeable.FC<IndicatorLayoutMetricValueProps> = (props) => {
  const { className, children, entity } = props;
  const t = useLang();

  const { result } = entity || {};
  const { indicator, numericValue } = result || {};
  const { suffixLabel, title, unit } = (indicator as Indicator) || {};

  const suffix = suffixLabel || title || unit?.shorthand;

  return (
    <My.Container 
    showContent 
    entity={entity} 
    ratio={0} 
    stretch={true} 
    hasPadding={false}
    className={className}
    >
      <My.Value suffix={t(suffix)} value={numericValue} />
    </My.Container>
  )
};

IndicatorLayoutMetricValue.defaultProps = IndicatorLayoutMetricValueDefaultProps;
IndicatorLayoutMetricValue.cls = cls;